import React from 'react'
import { Spinner } from 'react-bootstrap';
import { HealthCheckModel } from '../../../Helper';
import FailedIcon from '../../../Custom-imeges/FailedIcon';
import SuccessIcon from '../../../Custom-imeges/SuccessIcon'

interface Props {
  filterModelName: string | null;
  isLoading: boolean,
  healthCheckData: HealthCheckModel[] ;
}

const ModelsHealthStatus = ({filterModelName , isLoading, healthCheckData} : Props) => {
  const FilteredHealthCheckStatus = healthCheckData.filter((model) => model.modelName === filterModelName);

  return (
    <div className='Models-status-container'>
      <div className="Models-properties">
        <span className='Model-name'>Version name</span>
        <span className='Model-status'>Status</span>
        <span className='Model-note'>Note</span>
      </div>
      <div className="Models-status">
        {FilteredHealthCheckStatus && FilteredHealthCheckStatus.map((modelStatus) => (
        <div className={`Model-status-data ${modelStatus.status?.toLocaleLowerCase()}`}>
        <span className='Model-version-name'>{modelStatus.versionName}</span>
        <span className='Model-version-status'>
            {modelStatus.status?.toLocaleLowerCase() === "success" ? <SuccessIcon/> : <FailedIcon/>}
            <span>{modelStatus.status}</span>
        </span>
        <span className='Model-version-note'>{modelStatus.errors}</span>
        </div>
        ))}
        {isLoading && (<div className='spinner-container'>
          <Spinner />
          </div>)
        }
      </div>
      
    </div>
  )
}

export default ModelsHealthStatus
